module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/nudge/explore-nudge-3ca30ec08dc0a38f7a369aa43bf41f8c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/nudge/explore-nudge.svg
// module id = xTYJ
// module chunks = 24